import { html, unsafeCSS } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { DERStatus } from '~/ui/@types/der-status';
import { SvgUtility } from '~/ui/utils';

import { RadioChangeEventDetail } from './types';

import { styles as globalStyles } from '~/ui/scss/main.styles';
import DERFormElement from '~/ui/utils/der-form-element';
import { styles } from './radio.styles';

export class RadioButton extends DERFormElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) name: string = '';
    @property({ type: String }) value: string = '';
    @property({ type: String }) label: string = '';
    @property({ type: String }) status?: DERStatus;
    @property({ type: Boolean }) checked: boolean = false;
    @property({ type: Boolean }) disabled: boolean = false;
    @query('input') radioEl?: HTMLInputElement;

    constructor() {
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true,
        });
    }

    protected override firstUpdated(): void {
        // If this radio button is checked initially, notify the group
        if (this.checked) {
            this.dispatchEvent(
                new CustomEvent<RadioChangeEventDetail>('der.change', {
                    bubbles: true,
                    composed: true,
                    detail: {
                        name: this.name,
                        value: this.value,
                        checked: this.checked,
                    },
                })
            );
        }
    }

    private handleChange(e: Event): void {
        const target = e.target as HTMLInputElement;
        this.checked = target.checked;

        this.dispatchEvent(
            new CustomEvent<RadioChangeEventDetail>('der.change', {
                bubbles: true,
                composed: true,
                detail: {
                    name: this.name,
                    value: this.value,
                    checked: this.checked,
                },
            })
        );
    }

    override render() {
        return html`
            <label
                class=${classMap({
                    'c-radio__wrapper': true,
                    disabled: this.disabled,
                    error: this.status === 'error',
                    success: this.status === 'success',
                })}
            >
                <input
                    type="radio"
                    class="c-radio__input"
                    value="${this.value}"
                    .checked="${this.checked}"
                    ?disabled="${this.disabled}"
                    @change="${this.handleChange}"
                />
                <span class="c-radio"
                    ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 40" fill="none">
                        ${SvgUtility.systemCheck}
                    </svg></span
                >
                <span class="c-radio__label">${this.label}</span>
            </label>
        `;
    }
}
